<template>
    <div>
        <table class="table table-bordered table-striped table-sm">
            <thead>
                <tr>
                    <th>{{ $t('Label') }}</th>
                    <th>{{ $t('Value') }}</th>
                    <th>{{ $t('Command') }}</th>
                    <th>{{$t('Edit')}}</th>
                    <th>{{$t('Delete')}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="rec, id in records">
                    <td v-html="rec.label"></td>
                    <td v-html="rec.value"></td>
                    <td v-html="command_id_to_name[rec.command_id]"></td>
                    <td><a @click="edit_reply(id)"><i class="fa-edit"></i></a></td>
                    <td><a @click="remove_reply(id)"><i class="fa-remove"></i></a></td>
                </tr>
            </tbody>
        </table>

        <table class="table table-striped table-sm">
            <tbody>
                <tr>
                   <td>
                       <tooltip label="Label" placement="right">
                            <input
                                name="quick_rp_label"
                                v-model="record.label"
                                :class="{'form-control': true, 'is-invalid': errors.has('quick_rp_label')}"
                                type="text"
                                :placeholder="$t('Type a quick replay label')"
                                v-autocomplete="autoCompleteModules"
                                autocomplete="off"
                            />
                            <span
                                v-if="errors.has('quick_rp_label')"
                                class="help is-danger invalid-feedback"
                            >{{ $t(errors.first('quick_rp_label')) }}</span>
                        </tooltip>
                   </td>
                   <td>
                        <tooltip label="Value" placement="right">
                            <input
                                name="quick_rp_value"
                                v-model="record.value"
                                :class="{'form-control': true, 'is-invalid': errors.has('quick_rp_value')}"
                                type="text"
                                :placeholder="$t('Type a quick replay value')"
                                v-autocomplete="autoCompleteModules"
                                autocomplete="off"
                            />
                            <span
                                v-if="errors.has('quick_rp_label')"
                                class="help is-danger invalid-feedback"
                            >{{ $t(errors.first('quick_rp_label')) }}</span>
                        </tooltip>
                   </td>
                   <td>
                        <select v-model="record.command_id" class="form-control">
                            <option>Call a command</option>
                            <optgroup  v-for="serv in private_services" :label="serv.service_name">
                                <option v-for="comm in serv.commands" :value="comm.command_id">{{comm.command_name}}</option>
                            </optgroup>
                            <optgroup  v-for="serv in public_services" :label="serv.service_name">
                                <option v-for="comm in serv.commands" :value="comm.command_id">{{comm.command_name}}</option>
                            </optgroup>
                        </select>
                   </td>
                   <td>
                      <button 
                      type="button"
                      @click="save_reply"
                      class="btn btn-secondary btn-sm btn-block bl-0">Save</button>
                   </td>
                </tr>
            </tbody>
        </table>

    </div>
</template>

<script>
	export default {
		name: 'command-response-quick-replay',
		props: {
            autoCompleteModules: {
				type: Object,
				default: () => {},
			},
            records: {
				type: Array,
				default: () => [],
			},
            private_services: {
				type: Array,
				default: () => [],
			},
            public_services: {
				type: Array,
				default: () => [],
			},
            command_id_to_name: {
				type: Object,
				default: () => {},
			}

		},
		data() {
			return {
				record: {
                    'label': '',
                    'value': '',
                    'command_id': 0 // link the value to call directly a specific command id
                },
                record_id: -1,
			}
		},
		methods: {
			autoCompleteTextToHTML(str) {
				if (Object.keys(this.autoCompleteModules).length)
					return autoCompleteTextToHTML(str, this.autoCompleteModules)
				return str
			},
            autoCompleteTextToHTML(str) {
				if (Object.keys(this.autoCompleteModules).length)
					return autoCompleteTextToHTML(str, this.autoCompleteModules)
				return str
			},
            save_reply(){
                if(this.record_id < 0){
                    this.records.push(this.record);
                } else {
                    this.records[this.record_id] = this.record;
                    this.record_id = -1;
                }
                this.$emit('passQuickReplies', this.records);
                this.record = {'label': '', 'value': ''};
            },
            edit_reply(id){
                this.record = this.records[id];
                this.record_id = id;
            }, 
            remove_reply(id){
                this.records.splice(id, 1);
                this.$emit('passQuickReplies', this.records);
            }
		},
		watch: {
			
		},
		mounted() {
			//this.setDefaultMediaStyle()
		},
		computed: {
			//
		},
	}
</script>